module.exports = __webpack_public_path__ + "static/media/fumo.1dddc0a5.jpeg";